/* GENERADO — no editar a mano.
 *
 * Derivado de flow/src/components/shared/blocks/FeaturedStory/FeaturedStory.tsx quitandole los tipos, para
 * que la previsualizacion del back office editorial monte los MISMOS
 * componentes que renderiza /historias/[slug] en el sitio publico.
 *
 * Se regenera con:                 npm run historia:sync
 * Se verifica (falla si difiere):   npm run historia:diff
 *
 * Un cambio en el componente de flow se trae con `historia:sync`. Editar este
 * archivo directamente lo pierde en la siguiente regeneracion — y peor: hace
 * que la previsualizacion muestre algo distinto de lo que se publica, que es
 * justo lo que esa pantalla existe para evitar.
 *
 * La salida definitiva es publicar estos componentes en el Design System y que
 * los dos repos los consuman; ver
 * docs/superpowers/specs/2026-08-26-editorial-design-system-design.md §5.
 */
/*
 * Portado 1:1 desde Yool Design System
 * Fuente: yool-design-system/project/components/blocks/FeaturedStory/FeaturedStory.tsx
 * Sin adaptaciones de import
 */
import React from 'react';
import { renderHighlighted } from './highlight';
/* Large editorial story card — Apple-TV style. Photo background, dark scrim,
   pull-quote with a FancyYool highlight, and up to two pill buttons. */
export const FeaturedStory = ({
  eyebrow,
  quote,
  highlight,
  highlightColor = 'dark-cyan',
  text,
  image,
  imagePosition = 'center 30%',
  height = 520,
  align = 'left',
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  animateTitle = false
}) => {
  const gsl = animateTitle === true ? 'scroll' : animateTitle || undefined;
  const gradient = align === 'center' ? 'linear-gradient(0deg, rgba(0,0,0,.72) 0%, rgba(0,0,0,.4) 42%, rgba(0,0,0,.12) 100%)' : 'linear-gradient(90deg, rgba(0,0,0,.66) 0%, rgba(0,0,0,.38) 48%, rgba(0,0,0,.08) 100%)';
  const justify = align === 'center' ? 'center' : 'flex-start';
  return <section data-gsl-photo={gsl && image ? '1' : undefined} style={{
    position: 'relative',
    minHeight: Number(height),
    overflow: 'hidden',
    borderRadius: 20,
    background: '#121212',
    boxShadow: 'var(--shadow-sm)'
  }}>
      {image && <div className="gsl-photo-wrap" style={{
      position: 'absolute',
      inset: 0,
      overflow: 'hidden'
    }}>
          <img src={image} alt="" aria-hidden="true" style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: imagePosition
      }} />
        </div>}
      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      background: gradient
    }} />
      <div style={{
      position: 'relative',
      minHeight: Number(height),
      display: 'flex',
      alignItems: 'center',
      justifyContent: justify,
      padding: 48
    }}>
        <div style={{
        maxWidth: 620,
        textAlign: align
      }}>
          {eyebrow && <div style={{
          font: '600 11px/1 var(--font-sans)',
          letterSpacing: '.1em',
          textTransform: 'uppercase',
          color: 'rgba(255,255,255,.74)',
          marginBottom: 14
        }}>
              {eyebrow}
            </div>}
          <h3 data-gsl={gsl} style={{
          margin: 0,
          font: '700 var(--fs-display-md)/1.04 var(--font-sans)',
          letterSpacing: '-0.04em',
          color: '#fff'
        }}>
            {renderHighlighted(quote, highlight, highlightColor)}
          </h3>
          {text && <p style={{
          margin: '16px 0 0',
          font: '400 16px/1.6 var(--font-sans)',
          color: 'rgba(255,255,255,.85)',
          maxWidth: '52ch',
          marginLeft: align === 'center' ? 'auto' : 0,
          marginRight: align === 'center' ? 'auto' : 0
        }}>
              {text}
            </p>}
          {(primaryLabel || secondaryLabel) && <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 12,
          marginTop: 24,
          justifyContent: justify
        }}>
              {primaryLabel && <button type="button" onClick={onPrimary} style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 46,
            padding: '0 22px',
            border: 'none',
            borderRadius: 9999,
            background: '#fff',
            color: 'var(--yool-black)',
            font: '600 14px/1 var(--font-sans)',
            cursor: 'pointer'
          }}>
                  {primaryLabel}
                </button>}
              {secondaryLabel && <button type="button" onClick={onSecondary} style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 46,
            padding: '0 22px',
            border: '1.5px solid rgba(255,255,255,.5)',
            borderRadius: 9999,
            background: 'rgba(255,255,255,.10)',
            color: '#fff',
            font: '600 14px/1 var(--font-sans)',
            cursor: 'pointer'
          }}>
                  {secondaryLabel}
                </button>}
            </div>}
        </div>
      </div>
    </section>;
};
export default FeaturedStory;
